import React, { ReactElement } from 'react'
import { isNumber } from 'lodash'

import { colors } from '@lmc/common/constants'
// @ts-ignore
import { getStockText, getShowStockAlert } from '@lmc/common/utils/emar'
import LabelIcon from '../../LabelIcon'
import Popover from '../../../dataDisplay/Popover'
import Icon from '../../../general/Icon'

export type StockLevelCellProps = {
  quantityType?: string
  stockLog?: {
    amount1: number
    amount2: number
  }
  stock?: number
  stockAlertLevel?: number
  stockQuantityType?: string
}

export default function StockLevelCell({
  quantityType,
  stock,
  stockAlertLevel,
  stockLog,
  stockQuantityType,
}: StockLevelCellProps): ReactElement {
  // @ts-ignore
  if (!isNumber(stock)) return null

  const showAlert = getShowStockAlert({ stockAlertLevel, stockLog })

  return (
    <Popover
      content={showAlert ? 'Stock level low' : 'Stock level ok'}
      placement="top"
    >
      <div style={styles.stockLabel as React.CSSProperties}>
        <LabelIcon
          iconPosition="right"
          renderCustomIcon={() => (
            <div style={styles.icon}>
              <Icon
                name={showAlert ? 'incident' : 'tick-in-circle'}
                // @ts-ignore
                color={
                  stockAlertLevel
                    ? showAlert
                      ? colors.red
                      : colors.successgreen
                    : null
                }
                size={24}
              />
            </div>
          )}
          text={getStockText({ quantityType, stockLog, stockQuantityType })}
          textColor={showAlert ? colors.red : colors.black}
        />
      </div>
    </Popover>
  )
}

const styles = {
  icon: {
    height: 24,
    marginLeft: 10,
  },
  stockLabel: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
  },
}
